import React from "react";
import { Text, TextInput, useTranslation } from "@familyzone/component-library";
import { FilteringSourceCriteria } from "../criteriaTypes";

export interface ContentTypeCriteriaProps {
  criteria: FilteringSourceCriteria;
  disabled: boolean;
  onChange: (criteria: FilteringSourceCriteria) => void;
}

const ContentTypeCriteria: React.FC<ContentTypeCriteriaProps> = ({ criteria, disabled, onChange }) => {
  const { t } = useTranslation();

  if (Array.isArray(criteria.conditions)) {
    return <Text>{t("Invalid Criteria")}</Text>;
  }

  const handleChangeContentType = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange({ ...criteria, conditions: { expression: e.target.value } });
  };

  return (
    <TextInput
      name="content type"
      placeholder={t("Content Type Regex")}
      isDisabled={disabled}
      value={String(criteria.conditions.expression)}
      onChange={handleChangeContentType}
    />
  );
};

export default ContentTypeCriteria;
